import { Link } from "react-router-dom";
import { Icon, Typography } from "@/components/atoms";
import { EPermission, usePermissions } from "@/permissions";

interface RatingLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  to?: string;
  /** Permission the target page requires. Without it the name renders as plain text. */
  permission?: EPermission;
  hasIcon?: boolean;
}

export const RatingLink = (ratingLinkProps: RatingLinkProps) => {
  const { name, to, permission, hasIcon = false, className, ...props } = ratingLinkProps;
  const { hasPermission } = usePermissions();

  if (!to || (permission && !hasPermission(permission))) {
    return (
      <div className={className} {...props}>
        <Typography variant="paragraph">{name}</Typography>
      </div>
    );
  }

  return (
    <div className={className} {...props}>
      <Link to={to} className="flex w-fit items-center gap-x-2 hover:text-info" target="_blank" rel="noreferrer">
        <Typography variant="paragraph">{name}</Typography>
        {hasIcon && <Icon name="ExportSquare" size="xs" className="flex-shrink-0" />}
      </Link>
    </div>
  );
};

export const getJobLink = (jobId?: string) => (jobId ? `/bookings?job=${jobId}` : undefined);

export const getDriverProfileLink = (driverId?: string) => (driverId ? `/drivers/my-drivers/${driverId}/profile` : undefined);
